import script from "./PersonRoleCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonRoleCreator.vue?vue&type=script&setup=true&lang=js"

import "./PersonRoleCreator.vue?vue&type=style&index=0&id=bc86e64e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc86e64e"]])

export default __exports__